import React from 'react';
import DoughnutChart from './DoughnutChart';
import '../Css/RegConfirm.css';

function RegComplete() {
   const dataPoints = [
        { label: "已完成", y: 90 },
        { label: "未完成", y: 10 },
    ];
    

  return (
    <div className="wrapper">
      <div className="wrapper-content">
         <div className="wrapper-title">閣下已完成90%登記步驟,請到服務台簽署確認書,完成手續</div>
        <DoughnutChart dataPoints={dataPoints} />
      </div>  
    </div>
  )
}

export default RegComplete